"use client";

import clsx from "clsx";
import { useTranslation } from "react-i18next";
import StripePricingTable from "@/components/common/StripePricingTable";
import FancyLoader from "@/components/common/fancyLoader";
import Modal from "@/components/library/Modal";

interface SubscriptionModalProps {
  show: boolean;
  clientSecret: string;
  onClose: () => void;
}

export default function SubscriptionModal({
  show,
  clientSecret,
  onClose,
}: Readonly<SubscriptionModalProps>) {
  const { t: ot } = useTranslation("onboarding");

  return (
    <Modal
      open={show}
      onOpenChange={(open) => !open && onClose()}
      size="xl"
      header={{
        title: ot("readyToPurchase"),
      }}
      buttons={[
        {
          type: "secondary",
          onClick: onClose,
          children: ot("continueTryingGail"),
        },
      ]}
    >
      <div className={clsx("mb-6", "grid", "gap-4", "grid-cols-1", "md:grid-cols-2")}>
        <div className={clsx("max-w-sm", "mx-auto")}>
          <span className={clsx("mb-2", "text-lg", "block")}>{ot("youCan")}</span>
          <ul className={clsx("list-disc", "mx-auto", "inline-block", "mb-4", "list-inside")}>
            <li>{ot("readyToPurchasePoint1")}</li>
            <li>{ot("readyToPurchasePoint2")}</li>
            <li className={clsx("font-semibold")}>{ot("readyToPurchasePoint3")}</li>
          </ul>
        </div>
        <div className={clsx("max-w-sm", "mx-auto")}>{ot("readyToPurchaseDescription")}</div>
      </div>
      <div className={clsx("grid", "checkout_container")}>
        {clientSecret ? (
          <StripePricingTable
            pricing-table-id={process.env.NEXT_PUBLIC_STRIPE_PRICING_TABLE_ID || ""}
            publishable-key={process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY || ""}
            customer-session-client-secret={clientSecret}
          />
        ) : (
          <FancyLoader />
        )}
      </div>
    </Modal>
  );
}
